module.exports = __webpack_public_path__ + "static/UnclickTravelAssistance-517ef9ee513ce757cce0fd55d9a1d04f.png";